import '@babel/polyfill';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from './axios';
import './plugins/element.js';


Vue.prototype.$axios = axios;
Vue.prototype.$formRequest = axios.formRequest.post;

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
